module.exports = __webpack_public_path__ + "img/PRNT_05_mono_AE_00001.d54f08eb.png";